<script lang="ts">
	import arrowRight from '$lib/assets/images/icons/arrow-right-purple.svg';
	import compass from '$lib/assets/images/icons/compass.svg';
	import paper from '$lib/assets/images/icons/paper.svg';
	import signature from '$lib/assets/images/icons/signature.svg';
	import checkmark from '$lib/assets/images/icons/checkmark.svg';
	import __ from '$lib/stores/TranslationStore';
	import { page } from '$app/stores';
</script>

<div class="bg-white">
	<div class="container mx-auto py-16">
		<div class="flex flex-col justify-between gap-4 lg:flex-row">
			<h2 class="text-2xl text-dark lg:text-5xl">{$__('Como funciona?')}</h2>
			<a
				href="{$page.data?.location?.origin}/simuladores"
				class="flex items-center gap-3 text-xs font-semibold uppercase tracking-0.14 text-secondary-bright lg:text-lg"
			>
				{$__('Fazer simulação')}
				<img class="h-7 w-7" src={arrowRight} alt="Ir para página de simuladores" loading="lazy" />
			</a>
		</div>
		<div class="flex flex-col justify-around gap-14 pt-14 lg:flex-row lg:gap-24 lg:pt-20">
			<div>
				<img
					class="h-8 w-8 lg:h-12 lg:w-12"
					src={compass}
					alt="simulação do crédito"
					loading="lazy"
				/>
				<h3 class="mt-9 text-2xl font-semibold text-primary lg:text-4xl">
					{$__('Conte-nos o seu projeto')}
				</h3>
				<p class="mt-8 text-lg leading-6 text-dark">
					{$__(
						'O primeiro passo é conhecê-lo. O seu agente irá analisar a sua situação pessoal, conhecer os seus objetivos e encaminhá-lo para as soluções mais inteligentes para si.'
					)}
				</p>
			</div>
			<div>
				<img class="h-8 w-8 lg:h-12 lg:w-12" src={paper} alt="escolha da proposta" loading="lazy" />
				<h3 class="mt-9 text-2xl font-semibold text-primary lg:text-4xl">
					{$__('Deixe a negociação connosco')}
				</h3>
				<p class="mt-8 text-lg leading-6 text-dark">
					{$__(
						'Partilhe a sua documentação com segurança e tratamos de negociar as melhores condições para o seu crédito. Analise as opções com o seu agente e escolha a solução mais vantajosa.'
					)}
				</p>
			</div>
			<div>
				<img
					class="h-8 w-8 lg:h-10 lg:w-14"
					src={signature}
					alt="validação do projeto"
					loading="lazy"
				/>
				<h3 class="mt-9 text-2xl font-semibold text-primary lg:text-4xl">
					{$__('Tratamos de todo o processo')}
				</h3>
				<p class="mt-8 text-lg leading-6 text-dark">
					{$__(
						'O seu agente acompanhará todo o seu processo de formalização do crédito: desde a documentação, aos processo bancários e subscrições de seguro.'
					)}
				</p>
			</div>
			<div>
				<img
					class="h-8 w-8 lg:h-12 lg:w-12"
					src={checkmark}
					alt="formalização do crédito"
					loading="lazy"
				/>
				<h3 class="mt-9 text-2xl font-semibold text-primary lg:text-4xl">
					{$__('O projeto avançou!')}
				</h3>
				<p class="mt-8 text-lg leading-6 text-dark">
					{$__(
						'Estamos ao seu lado até ao final. Agendamos a escritura por si e tratamos das últimas formalidades até que tenha a chave na mão!'
					)}
				</p>
			</div>
		</div>
	</div>
</div>
